import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useControl, useControlReducer } from "../../../controlContext";
import { DollarSign, Plus, Trash2 } from 'react-feather'
import { Col, Button, Form, OverlayTrigger, Popover, Row } from "react-bootstrap";
import { FormLabel, Button as ButtonMui } from "@mui/joy";
import { ICN, REC } from "../../../../../shared/Data/typeDirs";
import { useNotificationContext } from '../../../../revised_components/contextProviders/notificationContext'
import { LangEntrySelector } from "./langEntrySelector";
import { IconSelector } from "./iconSelector";
import { reportIcons } from "../../../../../shared/Data/reportIcons";
import { ReportRecommendation } from "../../../../../shared/Objects/newReportObjects/reportRecommendation";
import { useDynamicTextAreaHeight } from "../utils/hooks";
import { useControlHeaderContext } from "../../../controlWrapperContext";
import { OpenChatButton } from "../../../../revised_components/OpenChatButton";
import { ChatWrapper } from '../../../../revised_components/ChatWrapper';
import '../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/recommendations.css'
import AddIcon from '@mui/icons-material/Add';

const BUDGET_NAMES = {
  eul: 'E.U.L.',
  erl: 'E.R.L',
  age: 'Age',
  quantity: 'Quantity',
  unit_type: 'Unit Type',
  unit_cost: 'Unit Cost',
  total_cost: 'Total Cost'
}

export function RecommendationsControl({ idx, name }) {
  const controls = useControl()
  const { [REC]: contentRecs, subcategories: parentId, _id: _report_blocks, _reports_v2 } = useMemo(() => controls && controls[idx] ? controls[idx] : {}, [controls, idx])
  const { settings: { readOnly: allReadOnly, lockMap } } = useControlHeaderContext()
  const readOnly = useMemo(() => (allReadOnly || (lockMap && lockMap[_report_blocks])), [allReadOnly, lockMap, _report_blocks])
  const controlReducer = useControlReducer()
  const displayNotif = useNotificationContext()
  const recommendationChange = useCallback((buffer, waitTime = 200) => {
    console.log('got these recs to send', buffer)
    if (controlReducer) {
      controlReducer({idx, name, type: 'changed', update:{[name]:buffer.value}, childAction:buffer.childAction})
    }
  }, [controlReducer, idx, name])

  

  const [buffer, setBuffer] = useStateBuffer(recommendationChange)
  const recs = useMemo(()=>((buffer && buffer.value) || contentRecs), [buffer, contentRecs])



  const addRecommendationBlock = useCallback(() => {
    if (recs.length >= 6) {
      if (displayNotif) {
        displayNotif('danger', "Maximum of 6 recommendation blocks per report block.")
      }
      return false
    }

    // let { _id: _report_blocks, _reports_v2 } = block
    const newBlock = new ReportRecommendation({
      _report_blocks, _reports_v2,
      content: '',
      report_icons: [],
    })
    recommendationChange({childAction: { type: 'add_blocks', name:'add', blocks:[newBlock]}, value: [
      ...recs,
      newBlock
    ]}, 1)
  }, [displayNotif, recommendationChange, recs, _report_blocks, _reports_v2])



  // const recommendationComponent = useMemo(() => {
  return (
    <div>
      {recs.map((recBlock, recBlockIdx) => (
        <RecommendationEntry
          key={recBlockIdx}
          recBlock={recBlock}
          recBlockIdx={recBlockIdx}
          recs={recs}
          parentId={parentId}
          recommendationChange={setBuffer}
          readOnly={readOnly}
          fieldName={`recommendation_${idx}_${recBlockIdx}`}
 
        />
      ))}
      {readOnly ? [] : (

        <div className="report-recommendation-add-container">
           <ButtonMui
                variant="soft"
                color="primary"
                className="btn-custom-primary-soft"
                onClick={addRecommendationBlock}
                startDecorator={<AddIcon />}
              >Add recommendation</ButtonMui>
        </div>
      )}
    </div>
  )
  // }, [recs, readOnly, addRecommendationBlock, parentId, recommendationChange])

  // return recommendationComponent

}

function useStateBuffer(callback, timeout_length = 200) {
  const [buffer, setBuffer] = useState(false)

  useEffect(() => {
    if (buffer === false) return
    let timeout_id = setTimeout(() => {
      callback(buffer)
      setBuffer(false)
    }, 200)
    return () => { clearTimeout(timeout_id) }
  }, [buffer])

  return [buffer, setBuffer]
}

function RecommendationEntry({readOnly, recBlock, recBlockIdx, recs, parentId, recommendationChange, fieldName }) {
  
  const [textContainerRef, textareaRef] = useDynamicTextAreaHeight(readOnly, recBlock.content)

    const contentUpdate = useCallback((val) => {
    // console.log('changing rec', recs, recBlockIdx, evt.target.value)
    recommendationChange({ childAction: {idx: recBlockIdx, type: 'changed', name:'content', update:{content: val}}, value: [
      ...recs.slice(0, recBlockIdx),
      {
        ...recs[recBlockIdx],
        content: val
      },
      ...recs.slice(recBlockIdx + 1)
    ]})
  }, [recBlockIdx, recs, recommendationChange])
  const value = recBlock.content
  const comma_split_total_cost = useMemo(()=>{
    if(!recBlock.total_cost) return '0'
    return parseFloat(recBlock.total_cost, 10).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})
  }, [recBlock.total_cost])
 
  const totalCostElement = (<div>Total Cost ${comma_split_total_cost}</div>)
  const deleteRecommendationBlock = useCallback(() => {
    const newRecState = [...recs.slice(0, recBlockIdx), ...recs.slice(recBlockIdx + 1)]
    recommendationChange({ childAction: {idx: recBlockIdx, type: 'delete_block', name:'kill', file: recBlock}, value:newRecState})
  }, [recommendationChange, recs, recBlockIdx])

  // const entryComponent = useMemo(() => {

  return readOnly ? (
    <div ref={textContainerRef} className="report-recommendation-readonly-container">
      <div className="report-recommendation-readonly-icon-container">
          <span className="report-recommendation-readonly-icons">
            {recBlock[ICN].map((icn, icnIdx) => <img key={icnIdx} alt={`${ICN} ${icn}`} className="report-recommendation-icon" src={reportIcons.find(repIcn => repIcn._name === icn).single} />)}
          </span>
      </div>
      <div className="report-recommendation-readonly-content">
        {recBlock.content}
      </div>
      {totalCostElement}
    </div>
  ) : (
    <div className="report-recommendation-block-container">   
      <div>
        <div>
          <FormLabel sx={{ m: 0 }}>Recommendation</FormLabel>
        </div>
        {recBlock[ICN].map((icn, icnIdx) => <img key={icnIdx} alt={`${ICN} ${icn}`} className="report-recommendation-icon" src={reportIcons.find(repIcn => repIcn._name === icn).single} />)}
      </div>

      <ChatWrapper
          textSourceRef={textareaRef}
          fieldName={fieldName}
          reportId={recBlock._reports_v2}
          blockId={recBlock._report_blocks}
          onChange={contentUpdate}
          onChatClose={() => {}}
        >
        <OverlayTrigger
          rootClose
          placement="right"
          trigger={['click']}
          overlay={(props) => RecommendationPopover(props, recBlock, recBlockIdx, recs, parentId, recommendationChange, textareaRef)}
        >
          <div ref={textContainerRef}>
            <Form.Control
              className="report-recommendation-block-textarea joy-like-markdown"
              ref={textareaRef}
              as="textarea"
              value={value}
              onChange={(evt) => contentUpdate(evt.target.value)}
            />
          </div>
        </OverlayTrigger>
      </ChatWrapper>
      <Row className="g-0" >
        <Col className="report-recommendation-budget-col">
          {totalCostElement}
        </Col>
        <Col className="report-recommendation-budget-col">
          <OverlayTrigger
            rootClose
            placement="bottom"
            trigger={['click']}
            overlay={(props) => BudgetPopover(props, recBlock, recBlockIdx, recs, false, recommendationChange, textareaRef)}
          >
            <Button size="sm" variant='info' ><DollarSign size={18} /></Button>
          </OverlayTrigger>
          <OverlayTrigger
            rootClose
            placement="right"
            trigger={['click']}
            overlay={(props) => ConfirmDeletePopover(props, deleteRecommendationBlock)}
          >
            <Button size="sm" variant='outline-activated'><Trash2 size={18} /></Button>
          </OverlayTrigger>
        </Col>
      </Row>
    </div>
  )
  // }, [recs, readOnly, deleteRecommendationBlock, parentId, recBlock, recBlockIdx, recommendationChange, textContainerRef, textareaRef, totalCostElement])

  // return entryComponent
}


function RecommendationPopover(popoverProps, recBlock, recBlockIdx, recs, parentId, recommendationChange, textRef) {
  return (
    <Popover {...popoverProps} className="report-recommendation-block-popover">
      <Popover.Header className="report-recommendation-block-popover-title">Icons & Language Selection</Popover.Header>
      <Popover.Body>
      
        <Row className="g-0">
          <IconSelector iconState={recBlock[ICN]} onChange={(newIconState) => {
            console.log('sending icon change', newIconState)
            recommendationChange({ childAction: {idx: recBlockIdx, type: 'changed', name:ICN, update:{[ICN]:newIconState}}, value: [
              ...recs.slice(0, recBlockIdx),
              {
                ...recs[recBlockIdx],
                [ICN]: newIconState
              },
              ...recs.slice(recBlockIdx + 1, recs.length)

            ]})
          }} />
        </Row>
      </Popover.Body>
      <Popover.Header>
        <Row className="g-0">
          <LangEntrySelector
            type={REC}
            _subcategories={parentId}
            onSelect={(selectedRecommendation) => {
              textRef.current.value = recs[recBlockIdx].content + selectedRecommendation.content
              recommendationChange({childAction: {
                update: {content:recs[recBlockIdx].content + selectedRecommendation.content},
                idx: recBlockIdx, 
                type: 'changed', 
                name: 'content', 
              }, value:[
                ...recs.slice(0, recBlockIdx),
                {
                  ...recs[recBlockIdx],
                  content: recs[recBlockIdx].content + selectedRecommendation.content
                },
                ...recs.slice(recBlockIdx + 1, recs.length)
              ]}, 1)
            }}
          />
        </Row>
      </Popover.Header>
    </Popover>
  )
}

function BudgetPopover(props, recBlock, recBlockIdx, recs, block, recommendationChange, textareaRef) {
  return (
    <Popover {...props} className="report-recommendation-block-popover">
      <Popover.Header className="report-recommendation-block-popover-title">Budget</Popover.Header>
      <Popover.Body>
      
        <Row>
          {Object.keys(BUDGET_NAMES).map((key, idx) => (
            <Col key={idx}>
              <Form.Label>{BUDGET_NAMES[key]}</Form.Label>
              <Form.Control type="text" value={recBlock[key]} onChange={evt => {
                let newRecData = {
                  ...recs[recBlockIdx],
                  [key]: evt.target.value,
                }
                const total_cost = `${parseFloat(`${parseFloat(newRecData.unit_cost || 0, 10) * parseFloat(newRecData.quantity || 0, 10)}`).toFixed(2)}`
                // total_cost = !~total_cost.indexOf('.') ? total_cost.slice(total_cost.indexOf('.')+3) : total_cost 
                newRecData.total_cost = !['unit_cost', 'quantity'].includes(key) ? newRecData.total_cost : total_cost
                console.log('changing')
                recommendationChange({childAction:{
                  update: newRecData,
                  idx: recBlockIdx, 
                  type: 'changed', 
                  name: key,
                },value:[
                  ...recs.slice(0, recBlockIdx),
                  newRecData,
                  ...recs.slice(recBlockIdx + 1)
                ]})
              }} />
            </Col>
          ))}
        </Row>
      </Popover.Body>
    </Popover>
  )
}

function ConfirmDeletePopover(props, deleteRecommendationBlock) {
  return (
    <Popover {...props}>
      <Popover.Header>
        Are you sure you want to delete this block?
      </Popover.Header>
      <Popover.Body>
        <Button variant="outline-secondary" onClick={deleteRecommendationBlock}>Yes</Button>
        <Button variant="outline-activated" onClick={() => document.body.click()}>No</Button>
      </Popover.Body>
    </Popover>
  )
}
